import { Record } from '../transit'

const State = Record({
  appName: '',
  appVersion: '',
  sentryUrl: '',
}, 'config')

const configReducer = (state = new State()) => state

export default configReducer



// WEBPACK FOOTER //
// ./src/common/config/reducer.js